import { HeaderButtons } from "@digits-shared/DesignSystem/Containers/Headers/HeaderButtons"
import { ExpandableContainer } from "@digits-shared/hooks/useDimensionAnimation"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

/*
  STYLES
*/

export const HeaderActionsExpandable = styled(ExpandableContainer)``

export const HeaderActions = styled.section`
  background:
    linear-gradient(${colors.translucentWhite10}, ${colors.translucentWhite10}),
    var(--header-background-image, none), var(--header-background-color, ${colors.teal});
  border: 1px solid var(--header-border-color, ${colors.transparent});
  margin-bottom: -38px;
  padding: 12px 16px 50px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  &:has(> ${HeaderActionsExpandable}) {
    display: grid;
    grid-template-rows: auto auto;
    align-items: center;
    gap: 12px;
    transition: gap 100ms ease-in-out;

    &:has(> ${HeaderActionsExpandable}:empty),
    &:has(> ${HeaderActionsExpandable}[style*="height: 0"]) {
      gap: 0;
    }

    grid-template-columns: 1fr;
    &:has(> *:nth-child(2):not(${HeaderActionsExpandable})) {
      grid-template-columns: 1fr 1fr;
    }
    &:has(> *:nth-child(3):not(${HeaderActionsExpandable})) {
      grid-template-columns: 1fr 1fr 1fr;
    }

    & > ${HeaderActionsExpandable} {
      grid-column: 1 / -1;
      grid-row: 2;
    }

    & > *:not(${HeaderActionsExpandable}) {
      grid-row: 1;

      &:not(${HeaderButtons}) {
        justify-content: flex-start;
      }
    }
  }

  &:empty {
    background-image: none;
    padding-top: 0;
    padding-bottom: 40px;
  }

  .mobile & {
    margin: 16px 0 -16px;
    padding: 16px 16px 26px;
    position: sticky;
    top: calc(var(--header-height) - 24px);
    border-bottom: none;
  }

  &.stuck {
    z-index: 1;
    border-radius: 0;
    border-color: ${colors.transparent};
    background: linear-gradient(
      to bottom,
      var(--header-background-color, ${colors.teal}) 0%,
      var(--header-background-color, ${colors.teal}) 60px,
      transparent 61px,
      transparent 100%
    );
  }
`
